import { render } from "./application_case.vue?vue&type=template&id=4b89638a"
import script from "./application_case.vue?vue&type=script&lang=js"
export * from "./application_case.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__